import React from "react";
import { Select } from "@mantine/core";
import { UploaderPreset } from "@/protocols/types/protocolDefinitions";
import { UPLOADER_PRESETS } from "../constants";

interface PresetSelectorProps {
    value: UploaderPreset | "custom";
    onChange: (value: UploaderPreset | "custom") => void;
    disabled?: boolean;
}

export const PresetSelector: React.FC<PresetSelectorProps> = ({ value, onChange, disabled }) => {
    const selectData = UPLOADER_PRESETS.map(p => ({ value: p.value, label: p.label }));

    return (
        <Select
            size="xs"
            label="File Types"
            value={value}
            data={selectData}
            onChange={(v) => v && onChange(v as UploaderPreset | "custom")}
            disabled={disabled}
        />
    );
};
